import { useOnlineStatus } from '../../hooks/useOnlineStatus'
import PropTypes from 'prop-types'

/**
 * Offline indicator component that shows a banner when the user is offline
 */
export const OfflineIndicator = ({ className = '' }) => {
  const isOnline = useOnlineStatus()

  // Don't render anything if online
  if (isOnline) {
    return null
  }

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 bg-dark-secondary border-b border-dark-border px-4 py-2 ${className}`}
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-center justify-center space-x-2">
        <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
        <span className="text-sm text-gray-300">
          You&apos;re offline - Some features may be limited
        </span>
      </div>
    </div>
  )
}

OfflineIndicator.propTypes = {
  className: PropTypes.string,
}

export default OfflineIndicator
